import {Component, OnInit} from '@angular/core';
import {TranslateService} from '../../services/translate.service';

@Component({
    selector: 'ageops-title-value-widget',
    templateUrl: './title-value-widget.component.html',
    styleUrls: ['./title-value-widget.component.styl']
})
export class TitleValueWidgetComponent implements OnInit {
    isFlipped: boolean;
    dir: string;
    lang: string;

    constructor(private translate: TranslateService) {
    }

    ngOnInit() {
        this.dir = this.translate.dir;
    }

}
